<template>
  <div>
    <DarkModeSwitcher />
    <MobileMenu />
    <div class="flex">
      <Navigation />
      <Content />
    </div>
  </div>
</template>

<script>
import DarkModeSwitcher from '@/components/ui/DarkModeSwitcher';
import MobileMenu from '@/views/layouts/MobileMenu';
import Navigation from '@/views/layouts/Navigation';
import Content from '@/views/layouts/Content';

export default {
  name: 'Main',
  components: { DarkModeSwitcher, MobileMenu, Navigation, Content },
  mounted() {
    cash('body')
      .removeClass('login')
      .addClass('app');
  },
};
</script>
